var map = {
	"./17-cn.webp": 1169,
	"./17.webp": 1170,
	"./27-cn.webp": 1171,
	"./27.webp": 1172,
	"./7-cn.webp": 1173,
	"./7.webp": 1174,
	"./angpao-bg-mobile.jpg": 1175,
	"./angpao-bg.jpg": 1176,
	"./angpao-cn.webp": 1177,
	"./angpao.webp": 1178,
	"./button.png": 1179,
	"./close-eye.png": 1180,
	"./coin-1.png": 1181,
	"./coin.png": 1182,
	"./ketupak-open.png": 1183,
	"./ketupak.png": 1184,
	"./ketupak_ribbon.png": 1185,
	"./rain-1.png": 1186,
	"./rain-2.png": 1187,
	"./rain-3.png": 1188,
	"./raya-bg-mobile.png": 1189,
	"./raya-bg.png": 1190,
	"./shine.png": 1191,
	"./star-1.png": 1192,
	"./star-2.png": 1193
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 460;